import {
  SET_AI_HEATMAP_DATA_SOURCE,
  SET_AI_PRODUCT_HEATMAP_DATA,
} from '../constants/ActionTypes.js';

export const defaultState = {};

export const resource = (state = defaultState, action) => {
  let newState;
  switch (action.type) {
    case SET_AI_HEATMAP_DATA_SOURCE:
      newState = { ...state, resource: action.data };
      break;
    case SET_AI_PRODUCT_HEATMAP_DATA:
      newState = { ...state, aiproductResource: action.data };
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};
